// utility function to get size
Object.size = function (obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

var highlightDimensionButton = function (listItem) {
    $(listItem).parents("ul").first().find("li").removeClass("selected-size");
    $(listItem).addClass("selected-size");
};

var CarImageDto = function (vehicle, hasRimGroups) {
    this.vehicleImageId = vehicle.vehicleImageId;
    this.vehicleImage360Id = vehicle.vehicleImage360Id;
    this.vehicleId = vehicle.vehicleId;
    this.alternativeVehicleUrl = vehicle.alternativeVehicleUrl;
    this.vehicleColor = vehicle.vehicleColor;
    this.tuning = vehicle.tuning;
    this.rimId = vehicle.rimId;
    this.rim360Id = vehicle.rim360Id;
    this.car360 = vehicle.car360;
    this.rimDiameter = vehicle.rimDiameter;
    this.rimManufacturer = vehicle.rimManufacturer;
    this.hasRimGroups = hasRimGroups;
};

// A 360 frame's angle and colour, as the CDN URL carries them:
// cars360/<car>-<angle>-<colour>-<tuning>-<rim>-<size>/... (MasterData templates and the hand-built legacy form alike)
var CAR_FRAME_URL = /\/cars360\/[^\/]+?-(\d+)-([0-9a-fA-F]{6})-/;

// The frames the server returned, keyed by the angle each was rendered at. How many there are is a
// property of the car-and-wheel pair (24 at 15 degrees, the legacy 30/60/90/120, or a single 90), so
// nothing may assume a count. A URL without an angle falls back to the legacy 30/60/90/120 numbering.
var carFrames = function (imageURLs) {
    return $.map(imageURLs, function (url, index) {
        var match = CAR_FRAME_URL.exec(url || "");
        return {
            url: url,
            angle: match ? parseInt(match[1], 10) : 30 * index + 30,
            color: match ? match[2] : null,
            $img: null,
            loaded: false,
            failed: false
        };
    });
};

// Rotation order. The legacy 30-120 set only renders one side of the car, so its far side is that side
// mirrored, as the legacy viewer showed it; any other set is rotated through as published.
var carRotationSequence = function (frames) {
    var sorted = frames.slice().sort(function (a, b) {
        return a.angle - b.angle;
    });
    var sequence = $.map(sorted, function (frame) {
        return {frame: frame, flipped: false};
    });
    var oneSided = frames.length > 1 && $.grep(frames, function (frame) {
        return [30, 60, 90, 120].indexOf(frame.angle) < 0;
    }).length === 0;
    if (oneSided) {
        sequence = sequence.concat($.map(sorted.slice().reverse(), function (frame) {
            return {frame: frame, flipped: true};
        }));
    }
    return sequence;
};

// The unflipped frame closest to the wanted angle.
var carClosestFrameIndex = function (sequence, wantedAngle) {
    var best = 0, bestDistance = 361;
    $.each(sequence, function (index, entry) {
        var distance = Math.abs(entry.frame.angle - wantedAngle) % 360;
        distance = Math.min(distance, 360 - distance);
        if (!entry.flipped && distance < bestDistance) {
            best = index;
            bestDistance = distance;
        }
    });
    return best;
};

var Vehicle = function (args) {

    // id of the img - this is required!
    this.imageElement = $("#" + args.imageElementId);

    // initialize with arguments or try to load values from the imageElement's data attributes
    // or fall back to defaults
    this.vehicleImageId = args.vehicleImageId || this.imageElement.data("vehicle-image-id");
    this.vehicleId = args.vehicleId || this.imageElement.data("vehicle-id");
    this.vehicleImage360Id = args.vehicleImage360Id || this.imageElement.data("vehicle-image-360-id");
    this.alternativeVehicleUrl = args.alternativeVehicleUrl
        || this.imageElement.data("vehicle-alternative-picture-url") || "";
    this.vehicleColor = args.vehicleColor || this.imageElement.data("vehicle-color") || "000000";
    this.tuning = args.tuning || this.imageElement.data("vehicle-tuning") || 0;
    this.rimId = args.rimId || this.imageElement.data("rim-id") || "";
    this.rim360Id = args.rim360Id || this.imageElement.data("rim-360-id") || "";
    this.car360 = args.car360 || this.imageElement.data("car-360") || false;
    this.rimDiameter = args.rimDiameter || this.imageElement.data("rim-diameter") || "";
    this.rimManufacturer = args.rimManufacturer || this.imageElement.data("rim-manufacturer") || "";

    this.imageURLs = function (callback) {
        var carImageDto = new CarImageDto(this, this.rimId !== "" || this.rimDiameter !== "");
        $.ajax({
            url: "/carselector/carimage",
            beforeSend: function (xhr) {
                xhr.setRequestHeader("X-CSRF-TOKEN", $("input[name='_csrf']").val());
            },
            data: $.param(carImageDto),
            contentType: "application/json; charset=utf-8",
            type: 'GET',
            processData: false
        }).done(function (data) {
            callback(data);
        }).fail(function() {
            callback([]);
        });
    };

    // 360 viewer: the frames in rotation order, the one shown, and a token that retires the load
    // callbacks of a frame set once a newer one (another rim, colour or tuning) has replaced it
    this.sequence = [];
    this.frameIndex = 0;
    this.frameSetToken = 0;
    // a new rim starts at 90 degrees; colour and tuning changes keep the angle rotated to
    this.keepAngle = false;

    this.initImage = function (callback) {
        this.imageURLs((function (imageURLs) {
            this.showFrames(imageURLs);
            callback();
        }).bind(this));
    };

    // redraw the car image
    this.refreshImage = function () {
        this.imageURLs(this.showFrames.bind(this));
    };

    // Replaces the shown frame set. Only the current frame is ever visible, and the previous picture
    // stays up until the new start frame has loaded, so a new set never flashes through its angles.
    // The start frame is 90 degrees (or the closest published one); a colour or tuning change keeps
    // the angle the customer rotated to (keepAngle).
    this.showFrames = function (imageURLs) {
        if (!imageURLs || !imageURLs.length) {
            return;
        }
        var self = this;
        var token = ++this.frameSetToken;
        var frames = carFrames(imageURLs);
        var sequence = carRotationSequence(frames);
        var current = this.sequence[this.frameIndex];
        var start = carClosestFrameIndex(sequence, current && this.keepAngle ? current.frame.angle : 90);
        this.keepAngle = false;
        var $spinner = $("#img-loader");
        var $noimage = $("#no-image");

        this.syncShownColor(frames);
        $spinner.fadeIn();
        this.loadFrame(sequence[start].frame, function (ok) {
            if (token !== self.frameSetToken) {
                return;
            }
            $spinner.fadeOut();
            if (!ok && self.shownColor && frames[0].color && frames[0].color !== self.shownColor) {
                // the CDN has no rendering of this colour although the server offered it: keep the car
                // on screen in the colour it is shown in, as when the server itself falls back
                self.markColorUnavailable(frames[0].color, self.shownColor);
                return;
            }
            $noimage.toggle(!ok);
            if (!ok) {
                return;
            }
            self.shownColor = frames[0].color;
            self.imageElement.find(".car_image, .turn_car").remove();
            self.sequence = sequence;
            self.frameIndex = start;
            $.each(frames, function (index, frame) {
                self.imageElement.append(self.frameImg(frame));
            });
            if (sequence.length > 1) {
                self.addRotationControls();
            }
            self.renderFrame();
            self.preloadFrames(token, start);
        });
    };

    // The img for a frame, created hidden on first use; its src is only set when the frame is loaded.
    this.frameImg = function (frame) {
        if (!frame.$img) {
            frame.$img = $("<img class='car_image' alt='' draggable='false'/>")
                .attr("id", "car_image_" + frame.angle)
                .css("visibility", "hidden");
        }
        return frame.$img;
    };

    // Loads a frame's image; calls back once with whether it loaded.
    this.loadFrame = function (frame, callback) {
        this.frameImg(frame);
        if (frame.loaded || frame.failed) {
            callback(frame.loaded);
            return;
        }
        frame.$img
            .one("load", function () {
                frame.loaded = true;
                callback(true);
            })
            .one("error", function () {
                frame.failed = true;
                callback(false);
            })
            .attr("src", frame.url);
    };

    // The remaining frames, nearest to the start first, a few at a time so the first turns are ready
    // at once and 24 large PNGs do not queue up behind each other.
    this.preloadFrames = function (token, start) {
        var self = this;
        var pending = [];
        for (var step = 1; step < this.sequence.length; step++) {
            $.each([start + step, start - step], function (i, index) {
                var entry = self.sequence[(index + self.sequence.length) % self.sequence.length];
                if (pending.indexOf(entry.frame) < 0 && !entry.frame.loaded) {
                    pending.push(entry.frame);
                }
            });
        }
        var next = function () {
            var frame = pending.shift();
            if (!frame || token !== self.frameSetToken) {
                return;
            }
            self.loadFrame(frame, function () {
                if (token === self.frameSetToken && self.sequence[self.frameIndex].frame === frame) {
                    self.renderFrame();
                }
                next();
            });
        };
        for (var lane = 0; lane < 4; lane++) {
            next();
        }
    };

    // Shows the current frame if it has loaded; otherwise the previous one stays up until it has.
    this.renderFrame = function () {
        var entry = this.sequence[this.frameIndex];
        if (!entry || !entry.frame.loaded) {
            return;
        }
        this.imageElement.find(".car_image").css("visibility", "hidden");
        entry.frame.$img.toggleClass("flipped", entry.flipped).css("visibility", "visible");
    };

    // One frame on (+1) or back (-1), skipping frames the CDN could not serve.
    this.rotate = function (direction) {
        var length = this.sequence.length;
        for (var tries = 0; tries < length; tries++) {
            this.frameIndex = (this.frameIndex + direction + length) % length;
            if (!this.sequence[this.frameIndex].frame.failed) {
                break;
            }
        }
        this.renderFrame();
    };

    this.addRotationControls = function () {
        var self = this;
        this.imageElement.find(".car_image").addClass("rotation-img");
        this.imageElement.prepend(
            "<div class='turn_car'>\n" +
            "<a class='turn_car_left' style='display: none;'></a>\n" +
            "<a class='turn_car_right' style='opacity: 1;'></a>\n" +
            "</div>"
        );
        this.imageElement.find(".turn_car_right").on("click", function () {
            self.rotate(-1);
        });
        this.imageElement.find(".turn_car_left").on("click", function () {
            self.rotate(1);
        });
        this.setMouseMove();
    };

    // Drag to rotate: one frame per (preview width / frame count) pixels, so a drag across the preview
    // turns the car once around whatever the frame count. Bound once per viewer, not per frame set.
    this.setMouseMove = function () {
        var self = this;
        var startX = null;
        $(document).off(".vehicle360");
        this.imageElement.off(".vehicle360")
            .on("pointerdown.vehicle360", ".car_image", function (e) {
                startX = e.originalEvent.clientX;
                return false;
            });
        $(document)
            .on("pointermove.vehicle360", function (e) {
                if (startX === null || self.sequence.length < 2) {
                    return;
                }
                var step = Math.max(8, self.imageElement.width() / self.sequence.length);
                var dx = e.originalEvent.clientX - startX;
                while (Math.abs(dx) >= step) {
                    // dragging right turns the car like the right arrow
                    self.rotate(dx > 0 ? -1 : 1);
                    startX += dx > 0 ? step : -step;
                    dx = e.originalEvent.clientX - startX;
                }
            })
            .on("pointerup.vehicle360 pointercancel.vehicle360", function () {
                startX = null;
            });
        this.imageElement.find(".car_image").css({"cursor": "grab", "touch-action": "pan-y"});
    };

    // The server serves a colour the car is rendered in, falling back to one it is when the chosen colour
    // is not published for this car and wheel. Show the colour actually rendered and mark the chosen one
    // unavailable, rather than a swatch that disagrees with the car.
    this.syncShownColor = function (frames) {
        var shown = frames[0].color;
        var wanted = String(this.vehicleColor);
        $(".change-color .color-unavailable").removeClass("color-unavailable").removeAttr("aria-disabled");
        if (!shown || shown.toLowerCase() === wanted.toLowerCase()) {
            return;
        }
        this.markColorUnavailable(wanted, shown);
    };

    // Marks a colour swatch unavailable and puts the picker back on the colour actually shown.
    this.markColorUnavailable = function (unavailable, shown) {
        $(".change-color [data-rgb='" + unavailable + "']").addClass("color-unavailable").attr("aria-disabled", "true");
        this.vehicleColor = shown;
        this.imageElement.attr("data-vehicle-color", shown);
        $("#car-colors-toggle").css("background", "#" + shown);
    };

    // move the car down
    this.tuningDown = function () {
        if (this.tuning == 4) {
            $(".tuning .arrow-down").addClass("disabled");
            return;
        }
        $(".tuning .arrow-up").removeClass("disabled");
        this.tuning++;
        this.keepAngle = true;
        this.refreshImage();
    };

    // move the car up
    this.tuningUp = function () {
        if (this.tuning == 0) {
            $(".tuning .arrow-up").addClass("disabled");
            return;
        }
        $(".tuning .arrow-down").removeClass("disabled");
        this.tuning--;
        this.keepAngle = true;
        this.refreshImage();
    };

    // change the car color
    this.changeColor = function (color) {
        this.vehicleColor = color;
        this.keepAngle = true;
        this.refreshImage();
    };

    // change the rim (and possibly the diameter)
    this.changeRim = function (rimId, rim360Id, car360, rimDiameter, rimManufacturer) {
        if (this.rimId === rimId && this.rim360Id === rim360Id && this.car360 === car360 && this.rimDiameter === Math.round(rimDiameter)) {
            return;
        }
        this.rimId = rimId;
        this.rim360Id = rim360Id;
        this.car360 = car360;
        if (rimDiameter) {
            this.rimDiameter = Math.round(rimDiameter);
        }
        this.rimManufacturer = rimManufacturer;
        this.refreshImage();
    };

};

var initRimsAddOnActions = function () {
    // initialise gettext
    try {
        ltd('wheelshop');
    } catch (e) {

    }
    var $spinner = $("#img-loader");
    $spinner.fadeOut();
    if ($("#carselector-kba").length) {
        $("#carselector-kba-series").hide();
        $("#carselector-kba-specific").hide();
        $("#carselector-kba-submit").prop("disabled", true);

        // toggling information about old vehicle registration
        $("#toggle-fahrzeugschein").on("click", function () {
            $("#todo-rename-me-2").slideToggle();
        });

        // CarSelector KBA HSN: Go to TSN when HSN is complete
        $('#carselector-kba-hsn').on('keyup', function (e) {
            $("#carselector-kba-error").fadeOut(300, function () {
                this.remove()
            });

            //if (!(e.keyCode >= 65 && e.keyCode >= 90) /* A-Z */ && !(e.keyCode >= 48 && e.keyCode >= 57) /* 0-9 */ && !(e.keyCode >= 96 && e.keyCode >= 105) /* 0-9 (Numpad) */ ) {
            // return;
            //}
            if (this.value.length == 4) {
                $('#carselector-kba-tsn').trigger("focus");
                return;
            }

            $("#carselector-kba-tsn").val("");
            $("#carselector-kba-series").hide();
            $("#carselector-kba-specific").hide();
            $("#carselector-kba-submit").prop("disabled", true);
        });

        // CarSelector KBA TSN: Submit AJAX request if HSN and TSN/VSN were supplied
        $('#carselector-kba-tsn').on('keyup', function () {
            this.value = this.value.toUpperCase();
            $("#carselector-kba-error").fadeOut(300, function () {
                this.remove()
            });

            if ($('#carselector-kba-hsn').val().length == 4 && (this.value.length == 8 || this.value.length == 6)) {
                var valueLength = this.value.length;
                $("#carselector-kba-series").hide();
                $("#carselector-kba-specific").hide();
                $("#carselector-kba-submit").prop("disabled", true);

                $.ajax({
                    url: contextPath + "/ws/ajax/vehicle/kba/" + $('#carselector-kba-hsn').val() + "/" + this.value + "/"
                }).done(function (data) {
                    var dropdown = $("#carselector-kba-series");
                    $(dropdown).find('option:not([value=""])').remove();
                    $.each(data, function (index, series) {
                        $(dropdown).append(
                            "<option value='" + series.key + "'>" + series.value.series_name + " " + series.value.engine_output_kw + " kW" + "</option>");
                    });

                    if (data.length == 1) {
                        // select first element
                        $(dropdown).val(data[0].key);
                        $(dropdown).trigger("change").hide();
                    } else {
                        $(dropdown).show().trigger("focus");
                    }
                }).fail(function (jqXHR) {
                    if (valueLength == 6) {
                        return;
                    }
                    // show foundation alert-box
                    $("#carselector-kba-error-anchor").after(
                        '<div data-alert class="alert-box alert" id="carselector-kba-error">' + l("carselector_kba_hsn_tsn_not_found") + '<a href="#" class="close">&times;</a>' + '</div>').parent().foundation();
                });
            }
        });

        // CarSelector KBA: load second dropdown (type-details)
        $('#carselector-kba-series').on('change', function () {
            $("#carselector-kba-specific").hide();
            //$("#carselector-kba-submit").prop("disabled", false);

            if (this.value == "") {
                return;
            }

            $.ajax({
                url: contextPath + "/ws/ajax/vehicle/typedetails/" + this.value + "/"
            }).done(function (data) {
                var dropdown = $("#carselector-kba-specific");
                $(dropdown).find('option:not([value=""])').remove();
                $.each(data, function (index, typedetails) {
                    $(dropdown).append(
                        "<option value='" + typedetails.vehicle_ids.join(',') + "'>" + typedetails.bolt_pattern + " min. Seriengröße " + typedetails.tire_min_coc_size + " Zoll" + "</option>");
                });
                if (data.length == 1) {
                    // select first element
                    $(dropdown).val(data[0].vehicle_ids.join(',')).hide();
                    // do not make dropdown visible
                    //$("#carselector-kba-submit").show();
                    $("#carselector-kba-submit").prop("disabled", false).trigger("focus");
                } else {
                    $("#carselector-kba-submit").prop("disabled", true);
                    $(dropdown).show().trigger("focus");
                }
            }).fail(function (jqXHR) {
                // show foundation alert-box
                $("#carselector-kba-error-anchor").after(
                    '<div data-alert class="alert-box alert" id="carselector-kba-error">' + l("carselector_kba_vehicle_not_found") + '<a href="#" class="close">&times;</a>' + '</div>').parent().foundation();
            });
        });

        // CarSelector KBA: show submit button if selected option from dropdown
        $("#carselector-kba-specific").on('change', function () {
            if (this.value != "") {
                $("#carselector-kba-submit").prop("disabled", false);
            }
        });
    }

    //toggle filters
    $(".toggle-hide").on('click', function () {
        $(this).closest(".row").next(".facet-wrapper").slideToggle();
        if ($(this).children("span").hasClass("fa-angle-up")) {
            $(this).children("span").removeClass("fa-angle-up").addClass("fa-angle-down");
        } else if ($(this).children("span").hasClass("fa-angle-down")) {
            $(this).children("span").removeClass("fa-angle-down").addClass("fa-angle-up");
        }
    });

    $facetsidebarForm = $("#facetsidebar form");
    $facetsidebarForm.on("change", "input,select", function (e) {
        var target = $(e.target);
        if (target.data("name") == "RimSizeAll") {
            $("input[name='RimSize']").prop("checked", false);
        } else if (target.data("name") == "RimColorAll") {
            $("input[name='RimColor']").prop("checked", false);
        } else if ($(e.target).attr('name') == "type") {
            $("input[name='price']").val("");
            $("input[name='brand']").val("");
            $("input[name='size']").val("");
            $("input[name='color']").val("");
            $("input[name='model']").val("");
        } else if (target.attr('name') == "priceCategory") {
            if(target.prop('checked')) {
                $("input[name='priceCategory']").each((index, value) => {
                    if(value.value != target.prop('value')) value.checked = false;
                });
            }
        }
        $facetsidebarForm.trigger('submit');
    });

    //toggle color filter check
    $(".colors input").on('click', function () {
        $(this).next("label").toggleClass("checked");
    });

    //close detail view with a button
    $('.rim-flow-details-placeholder').on('click', '.hide-details', function () {
        $(".item").removeClass("highlighted");
        $(this).parents(".rim-flow-details-placeholder").addClass("hide");
    });

    //hide item details
    $("#listing-items .hide-details").on('click', function () {
        $(this).parents(".item-detail").removeClass("visible").slideUp();
    });

    //tuning up ad down
    $(".tuning span").on("click", function () {
        $(this).removeClass("disabled");
        var direction = $(this).attr("class");

        if (direction === "arrow-down") {
            vehicle.tuningDown();
        } else if (direction === "arrow-up") {
            vehicle.tuningUp();
        }

    });

    //car color change
    $(".change-color div a").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        $("#drop").css("left", "-99999px");
        if ($this.data("rgb") !== vehicle.vehicleColor) {
            vehicle.changeColor($this.data("rgb"));
        }

        $(".car-colors-tooltip").removeClass('active')

    });

    // removing rims from compare
    $('.rims-comparison').on("click", '.rim-removing', function () {
        var $itemRim = $(this).closest('.item-rim');
        var $attrID = 'data-id';
        var $comparingRims = $('#comparing-rims');

        var $parentDiv = $(this).closest($itemRim);
        var $idRemovingRim = $parentDiv.attr($attrID); // ID of removing rim item
        var $indexOfRemovingRim = 0; // Index of removing rim item

        //search index of current element
        $comparingRims.children().each(function (index, el) {
            if ($(el).attr($attrID) === $idRemovingRim) {
                $indexOfRemovingRim = index;
            }
        });

        removeProductFromStickyBar($idRemovingRim);

        removeRimFromCompare($indexOfRemovingRim, function () {
            $(".comparing-product-" + $idRemovingRim).remove(); // removing of current item
            if ($comparingRims.children().length === 0) {
                $(".comparing-rims-container").addClass("hidden");
            }
            removingAttrChekBox($attrID, $idRemovingRim);
        });
    });

    //adding rim-item to compare
    $("#listing").on('click', '.add-rim-tocompare', function () {

        var $thisCheckBox = $(this);
        var $itemRim = '.item-rim';
        var $attrID = 'data-id';
        var $comparingRims = $('#comparing-rims');
        var $currentID = $(this).closest($itemRim).attr($attrID);// ID of removing rim item
        //if unchecked
        if ($thisCheckBox.is(":not(:checked)")) {
            var $indexOfRemovingRim = 0; // Index of removing rim item
            var $toRemove; // Element of removing rim item
            //search index of current element
            //searching the same element, if attr checked was removed
            $comparingRims.children().each(function (index, el) {
                if ($(el).attr($attrID) === $currentID) {
                    $indexOfRemovingRim = index;
                    $toRemove = $(el);
                }
            });
            removeProductFromStickyBar($currentID);
            if ($toRemove) {
                removeRimFromCompare($indexOfRemovingRim, function () {
                    $toRemove.remove();
                    if ($comparingRims.children().length === 0) {
                        $(".comparing-rims-container").addClass("hidden");
                    }
                });
            }
            return;
        }

        //if < 3 items in preferred list
        if ($comparingRims.children().length < 3) {

            var $closestItem = $thisCheckBox.closest($itemRim);
            var $parentContainer = $closestItem.clone();
            $parentContainer.removeClass("product-" + $currentID);
            $parentContainer.addClass("comparing-product-" + $currentID);
            var selectedRimSize = $parentContainer.find(".selected-size").data("rim-size");
            var $offsetSelectorValue = $closestItem.find('.select-offset').val();
            addRimToCompare($currentID, selectedRimSize, $offsetSelectorValue, 0, function () {
                $parentContainer
                    .find('.item')
                    .prepend('<i class="fa fa-trash-o rim-removing" aria-hidden="true"></i>'); // adding of removing button
                $parentContainer.find('.comparing-container').remove(); // removing of checkbox
                $parentContainer.find('.cloudzoom').CloudZoom();
                //adding the element to compare
                if ($comparingRims.children().length === 0) {
                    $(".comparing-rims-container").removeClass("hidden");
                }
                $comparingRims.each(function () {
                    $(this).append($parentContainer);
                });
                $parentContainer.data("selected-size", selectedRimSize);
                var $offsetSelector = $parentContainer.find('.select-offset');
                $offsetSelector[0].id = "comparing-product-offsetSelect-" + $currentID;
                $offsetSelector.on("change", function () {
                    changeOffset(this);
                });
                var $offsetSelectorOption = $offsetSelector.find('option[value="' + $offsetSelectorValue + '"]')[0];
                if ($offsetSelectorOption) {
                    $offsetSelectorOption.selected = true;
                }

                addProductToStickyBar($currentID, $offsetSelectorValue);

                var message = "" + $comparingRims.children().length + " " + ACC.rimPreferredAddedProducts;
                var wrapperDiv = new BackgroundBox('wrapperBackground', message);
                wrapperDiv.show();
                wrapperDiv.hideWithDelay(1750);

            }, function () {
            });

            return;
        }

        comparePopUp($currentID, $thisCheckBox, $itemRim, $comparingRims, $attrID);
    });

    //showing window with information if user have more then 3 products in comparing area
    var comparePopUp = function ($currentID, $thisCheckBox, $itemRim, $comparingRims, $attrID) {
        //if 3 or more items in preferred list
        var $message = ACC.rimPreferredConfirmation;
        var $yes = ACC.rimPreferredYes;
        var $no = ACC.rimPreferredNo;

        setTimeout(function () {
            var $wrapperDiv = new BackgroundBox('wrapperBackground', $message);

            var $childDiv = $($wrapperDiv.domElement.lastChild);

            $($childDiv).append('<div style="margin-top: 15px;">' +
                '<a class="wrapperBackground__button-yes">' + $yes + '</a>' +
                '<a class="wrapperBackground__button-no">' + $no + '</a>' +
                '</div>');

            var $cssObj = {
                'display': 'inline-block',
                'padding': '10px',
                'font-size': '14px',
                'border': '1px solid #dadada',
                'box-shadow': '2px 2px 2px #dadada',
                'border-radius': '4px',
                'margin': '5px 10px',
                'text-decoration': 'none'
            };

            var $wrapperBackground__buttonNo = $('.wrapperBackground__button-no');
            var $wrapperBackground__buttonYes = $('.wrapperBackground__button-yes');
            $wrapperBackground__buttonNo.css($cssObj);
            $wrapperBackground__buttonYes.css($cssObj);
            var $closestItem = $thisCheckBox.closest($itemRim);
            var $parentContainer = $closestItem.clone();
            $parentContainer.removeClass("product-" + $currentID);
            $parentContainer.addClass("comparing-product-" + $currentID);
            var selectedSize = $parentContainer.data("selected-size");
            var selectedOffset = $parentContainer.find(".select-offset").val();
            $wrapperBackground__buttonYes.on('click', function () {

                addRimToCompare($currentID, selectedSize, selectedOffset, 0, function () {
                    var $currentID = $($comparingRims.children()[0]).attr($attrID);
                    $($comparingRims.children()[0]).remove();
                    removingAttrChekBox($attrID, $currentID);
                    removeProductFromStickyBar($currentID);
                    $parentContainer
                        .find('.item')
                        .prepend('<i class="fa fa-trash-o rim-removing" aria-hidden="true"></i>'); // adding of removing button
                    $parentContainer.find('.comparing-container').remove(); // removing of checkbox
                    //adding the element to compare
                    $comparingRims.each(function () {
                        $(this).append($parentContainer);
                    });

                    var selectedRimSize = $parentContainer.find(".selected-size").data("rim-size");
                    $parentContainer.data("selected-size", selectedRimSize);
                    var $offsetSelector = $parentContainer.find('.select-offset');
                    $offsetSelector[0].id = "comparing-product-offsetSelect-" + $currentID;
                    $offsetSelector.on("change", function () {
                        changeOffset(this);
                    });
                    var $offsetSelectorValue = $closestItem.find('.select-offset').val();
                    var $offsetSelectorOption = $offsetSelector.find('option[value="' + $offsetSelectorValue + '"]')[0];
                    if ($offsetSelectorOption) {
                        $offsetSelectorOption.selected = true;
                    }

                    addProductToStickyBar($parentContainer.attr($attrID), $offsetSelectorValue);

                }, function () {
                });

                $wrapperDiv.hideWithDelay(100);
            });
            $wrapperBackground__buttonNo.on('click', function () {
                $thisCheckBox.prop("checked", false);
                $wrapperDiv.hideWithDelay(100);
            });

            $wrapperDiv.show();

        }, 300);

    };

    //removing attr checked in common list of rims, if product was deleted from comparing
    var removingAttrChekBox = function ($attrID, $idOfRemovingRim) {
        // tiles can sit in a column wrapper (rdlite), so look for them at any depth
        $("#listing-items").find(".item-rim").each(function (index, el) {
            if ($(el).attr($attrID) === $idOfRemovingRim) {
                var $addRimToCompareCheckbox = $(el).find('.add-rim-tocompare');
                $addRimToCompareCheckbox.removeAttr('checked');
                $addRimToCompareCheckbox.prop('checked', false);
            }
        });
    };

    var addRimToCompare = function (rimGropId, selectedRimSize, selectedRimOffset, toRemoveIndex, callback, error) {
        var rimSelectorType = $(".rim-selection-type").val();
        $.ajax({
            type: 'GET',
            url: '/rims/compare/add',
            data: {
                rimGroup: rimGropId,
                rimSize: selectedRimSize,
                rimOffset: selectedRimOffset,
                rimSelectorType: rimSelectorType,
                toRemove: toRemoveIndex
            }
        }).done(function () {
            callback();
        }).fail(function () {
            error();
        });
    };

    var removeRimFromCompare = function (toRemoveIndex, callback) {
        var rimSelectorType = $(".rim-selection-type").val();
        $.ajax({
            type: 'GET',
            url: '/rims/compare/remove',
            data: {
                rimSelectorType: rimSelectorType,
                toRemove: toRemoveIndex
            }
        }).done(function () {
            callback();
        });
    };

    var addProductToStickyBar = function ($currentID, $offsetSelectorValue) {
        var $stickyBarProduct = $(".product-" + $currentID).clone();
        if ($stickyBarProduct.length === 0) {
            return;
        }
        $stickyBarProduct.removeClass("product-" + $currentID);
        $stickyBarProduct.addClass("comparing-product-" + $currentID);
        $stickyBarProduct.addClass("sticky-bar-compare-column item-rim");
        $stickyBarProduct.find(".rim_item").removeClass("highlighted")
        $stickyBarProduct.find(".comparing-container").hide();
        $stickyBarProduct.find(".rim-sizes").hide();
        $stickyBarProduct.find(".fa-search-plus").hide();
        $stickyBarProduct.find(".rim-price-element-label").addClass("hidden");
        $stickyBarProduct.find(".more-offset-paragraph").addClass("hidden");
        $stickyBarProduct.find(".select-offset").addClass("hidden");
        $stickyBarProduct.find(".select-rim").addClass("hidden");
        $stickyBarProduct.find(".bestseller-container").hide();
        $stickyBarProduct.find(".rim-picture img").addClass("sticky-bar-comparison-product-image img");
        $stickyBarProduct.find(".rim-picture").removeClass("rim-picture").addClass("sticky-bar-comparison-product-image");
        $stickyBarProduct.find(".sticky-bar-comparison-top-actions").removeClass("hidden")
        $($(".sticky-bar-compare-column.sticky-bar-empty-slot")[0]).before($stickyBarProduct);
        $($(".sticky-bar-compare-column.sticky-bar-empty-slot")[0]).remove();
        var $stickyBarComparisonProducts = $('.stickyBarComparisonProducts');
        if ($stickyBarComparisonProducts[0] && $stickyBarComparisonProducts[0].classList.contains("hidden")) {
            $stickyBarComparisonProducts.removeClass("hidden");
            $('#stickyBarShowContainerButton').addClass("hidden");
        }

        $stickyBarProduct.find('.rim_item ').on("click", function () {
            $(this).find("form").trigger('submit');
        });

        var offsetSelector = $stickyBarProduct.find('.product-offsetSelect-' + $currentID);
        offsetSelector.val($offsetSelectorValue);
        updateContainerGroupsEqualHeightByMax();
    };

    var removeProductFromStickyBar = function ($idRemovingRim) {
        var $stickyBarProduct = $("#stickyBarComparisonContainer .comparing-product-" + $idRemovingRim);
        if ($stickyBarProduct.length > 0) {
            $stickyBarProduct.remove();
            var emptySlide = "<div class=\"sticky-bar-compare-column sticky-bar-empty-slot\">" +
                "<p class=\"add-product-to-compare-text\">" + $("#add-to-compare").text() + "</p>" +
                "</div>";
            $("#stickyBarComparisonContainer .sticky-bar-compare-buttons-container").before(emptySlide);
            if ($('.sticky-bar-compare-column.item-rim').length == 0) {
                $('.stickyBarComparisonProducts').addClass("hidden");
                $('#stickyBarShowContainerButton').addClass("hidden");
            }

            updateContainerGroupsEqualHeightByMax();
        }
    };

    var changeOffset = function ($this) {
        var selectedGroupId = $($this).closest(".item-rim").data("id");
        var selectedOption = $($this).find('option:selected');
        var selectedRimSize = $($this).closest("[data-id='" + selectedGroupId + "']").data("selected-size");
        var offsetSelectors = $(".product-offsetSelect-" + selectedGroupId);

        offsetSelectors.val(selectedOption.val());

        if (offsetSelectors.length > 1) {
        	var rimSelectorType = $(".rim-selection-type").val();
            $.ajax({
                type: 'GET',
                url: '/rims/compare/update',
                data: {
                    rimGroup: selectedGroupId,
                    rimSize: selectedRimSize,
                    rimOffset: selectedOption.val(),
                    rimSelectorType: rimSelectorType
                }
            });
        }

        $("[data-id='" + selectedGroupId + "']").each(function () {
            var dropdown = $(this);
            var rimPriceElement = dropdown.closest(".item-rim").find(".rim-price-element")[0];
            var minLast30DaysRimPriceElement = dropdown.closest(".item-rim").find(".rim-min-30-days-price")[0];
            var reducedPriceAfterDiscountValue = dropdown.closest(".item-rim").find(".reduced-price-value")[0];
            var reducedPriceAfterDiscountMessage = dropdown.closest(".item-rim").find(".voucher-campaign-message")[0];
            var rimPriceBeforeDiscount = dropdown.closest(".item-rim").find(".rim-price-before-discount")[0];
            var rimPriceParagraph = dropdown.closest(".item-rim").find(".rim-price")[0];

            $(rimPriceElement).html(selectedOption.data('rim-price'));
            $(rimPriceBeforeDiscount).html(selectedOption.data('price-before-discount'));
            $(minLast30DaysRimPriceElement).html(selectedOption.data('rim-min-price'));
            $(reducedPriceAfterDiscountMessage).html(selectedOption.data('rim-voucher-message'));
            $(reducedPriceAfterDiscountValue).html(selectedOption.data('rim-voucher-reduced-price'));
            $(rimPriceParagraph).show();

            // the badge follows the exact offset/width article now selected, not the whole group
            dropdown.closest(".item-rim").find("[data-recommended-badge]").toggle(!!selectedOption.data('rim-recommended'));
            var $priceElement = $(".rim-price-element-" + selectedGroupId);
            if ($priceElement.length > 0) {
                $priceElement.html(selectedOption.data('rim-price'));
            }
            var $minPriceLast30DaysElement = $(".rim-min-30-days-price-" + selectedGroupId);
            if ($minPriceLast30DaysElement.length > 0) {
                $minPriceLast30DaysElement.html(selectedOption.data('rim-min-price'));
            }

            var $reducedPriceAfterDiscountValue = $(".reduced-price-value-" + selectedGroupId);
            if ($reducedPriceAfterDiscountValue.length > 0) {
                $reducedPriceAfterDiscountValue.html(selectedOption.data('selected-voucher-reduced-price'));
            }

            var $reducedPriceAfterDiscountMessage = $(".voucher-campaign-message-" + selectedGroupId);
            if ($reducedPriceAfterDiscountMessage.length > 0) {
                $reducedPriceAfterDiscountMessage.html(selectedOption.data('selected-voucher-message'));
            }

            var bestsellerImage = $(this).parents(".item").find('.bestseller-container');
            bestsellerImage.hide();
        });
    };

    // view tires and update car image with rim on click
    $("#listing").on("click", "#listing-items .item-rim, #comparing-rims .item-rim", function (e) {
        var $this = $(this);
        if (e.target.localName != "select" && e.target.localName != "button" && !$this.find(".item").hasClass("highlighted")) {
            $(".item-rim .item").removeClass("highlighted").find(".view-tires").removeClass("disabled dropdown-selected");
        }
        $this.find(".item").addClass("highlighted");
        if (!$this.find(".details-step2:visible").length) {
            $(".view-tires").removeClass("disabled dropdown-selected");
            $(".details-step2").fadeOut();
        }

        // car image
        if ($('#preview-container').length) {
            vehicle.changeRim($this.data("img-id"), $this.data("img-360-id"), $this.data("car-360") || false, $this.data("selected-size"), $this.data("rim-manufacturer"));
        }
    });

    $(".item").on("click", ".view-tires:not(.disabled)", function (event) {
        var url = "";
        var $this = $(this);
        var sizes = (Object.size($this.siblings(".details-container").find(".selected-size").data("rims")));
        if ($this.hasClass("dropdown-selected")) {
            url = $this.siblings(".details-container").find("select:visible").val();
            if (url) { // require a URL
                window.location = url; // redirect
            }
            return false;
        } else {
            if (sizes > 1) {
                var rimGroupId = $this.siblings(".details-container").find(".selected-size").data("rim-group-id");
                $(".details-step2 select").hide();
                var $step2 = $this.siblings(".details-container").find(".details-step2");
                var $select = $step2.find("select#" + rimGroupId);
                $select.show();
                $(".view-tires").removeClass("disabled dropdown-selected");
                $(".details-step2").fadeOut("fast");
                $step2.fadeIn("fast");
                $select.find("option:selected").trigger('change');
            } else if (sizes === 1) {
                url = $this.siblings(".details-container").find(".selected-size").data("rim-url");
                if (url) {
                    window.location = url;
                }
                return false;
            } else {
                //do nothing
            }
        }

    });

    $(".details-step2 select").on('change', function () {
        var $this = $(this);
        $this.parents(".details-container").siblings(".view-tires").removeClass("disabled").addClass("dropdown-selected");
    });

    $(".details-step2 .close-x").on("click", function (e) {
        var $this = $(this);
        e.preventDefault();
        $this.parents(".details-container").siblings(".view-tires").removeClass("disabled dropdown-selected");
        $this.parent().fadeOut();
    });

    $("#listing").on('click', '.select-rim-size', function (event) {
        event.preventDefault();

        $("[data-rim-group-id='" + $(this).data("rim-group-id") + "']").each(function () {
            var $this = $(this);
            //update displayed rims size
            $this.parents(".item").find(".set-size em").html($this.data("rim-size") + '"');
            $this.parents(".item").find(".set-price em").html($this.data("rim-price"));

            // save which one is selected
            highlightDimensionButton($this);

            // update the rim info on container
            $this.parents(".item-rim").data("selected-size", $this.data("rim-size"));

            //update offset selector

            var dropdown = $this.parents(".item-rim").find(".select-offset")[0];
            var div = $this.parents(".item-rim").find("#selectWrapper")[0];
            var dropdownLabel = $this.parents(".item-rim").find(".more-offset-paragraph")[0];
            var offsetEmptyLabel = $this.parents(".item-rim").find("#offsetEmptyLabel")[0];
            var submitButton = $this.parents(".item-rim").find(".rimSubmitButton")[0];
            $(dropdown).find('option:not([value=""])').remove();

            var rims = $this.data("rim-rims");
            console.log(rims);
            var rimPriceElement = $this.parents(".item-rim").find(".rim-price-element")[0];
            var rimPriceBeforeDiscount = $this.parents(".item-rim").find(".rim-price-before-discount")[0];
            var rimMinPriceLast30Days = $this.parents(".item-rim").find(".rim-min-30-days-price")[0];
            var rimReducedPriceAfterDiscountValue = $this.parents(".item-rim").find(".reduced-price-value")[0];
            var rimReducedPriceAfterDiscountMessage = $this.parents(".item-rim").find(".voucher-campaign-message")[0];
            var rimPriceHidenLabel = $this.parents(".item-rim").find("#priceEmptyLabel")[0];
            var rimPriceParagraph = $this.parents(".item-rim").find(".rim-price")[0];
            var rimInfo = $this.parents(".item-rim").find(".selectWrapper").find(".rim-info")[0];
            if (rims.length == 1) {
                if ($(rimPriceElement) && $(rimPriceHidenLabel)) {

                    $(rimPriceElement).html(rims[0].price);
                    $(rimMinPriceLast30Days).html(rims[0].minPriceLast30Days);
                    $(rimReducedPriceAfterDiscountValue).html(rims[0].reducedPrice);
                    $(rimReducedPriceAfterDiscountMessage).html(rims[0].message);
                    if (rimPriceBeforeDiscount) {
                        $(rimPriceBeforeDiscount).html(rims[0].priceBeforeDiscount);
                    }
                    $(rimPriceHidenLabel).hide();
                    $(rimPriceParagraph).show();
                }
                $(dropdown).append(
                    "<option selected value='" + rims[0].id + "' data-rim-price='" + rims[0].price + "' data-price-before-discount='" + rims[0].priceBeforeDiscount + "' data-rim-min-price='" + rims[0].minPriceLast30Days  + "' data-rim-voucher-price='" + rims[0].reducedPrice  + "' data-rim-voucher-message='" + rims[0].message  + "' data-rim-recommended='" + rims[0].recommended + "'>" + offsetTranslation + rims[0].offset + milimetersTranslation + " / " + widthTranslation + rims[0].width + inchTranslation + "</option>");
                $(dropdownLabel).show();
                $(dropdown).hide()

                $(rimInfo).remove();

                $($this.parents(".item-rim").find(".selectWrapper")).append('<div class="rim-info">' + offsetTranslation + rims[0].offset + milimetersTranslation + " / " + widthTranslation + rims[0].width + inchTranslation + '</div>')
            } else {
                if ($(rimPriceElement) && $(rimPriceHidenLabel)) {
                    $(rimPriceElement).html(rims[0].price);
                    if (rimPriceBeforeDiscount) {
                        $(rimPriceBeforeDiscount).html(rims[0].priceBeforeDiscount);
                    }
                    $(rimPriceHidenLabel).hide();
                    $(rimPriceParagraph).show();
                }
                $.each(rims, function (index, rim) {
                    $(dropdown).append(
                        "<option value='" + rim.id + "' data-rim-price='" + rim.price + "' data-price-before-discount='" + rim.priceBeforeDiscount + "' data-rim-min-price='" + rim.minPriceLast30Days + "' data-rim-voucher-message='" + rim.message  + "' data-rim-voucher-reduced-price='" + rim.reducedPrice  + "' data-rim-recommended='" + rim.recommended + "'>" + offsetTranslation + rim.offset + milimetersTranslation + " / " + widthTranslation + rim.width + inchTranslation + "</option>");
                });

                $(rimInfo).remove()
                $(dropdown).show()
            }

            // the badge follows the article the shopper is now looking at, not the whole group
            $this.parents(".item-rim").find("[data-recommended-badge]").toggle(!!(rims[0] && rims[0].recommended));

            var $groupId = $(rimPriceElement).closest($('.item-rim')).attr('data-id');
            var $offsetSelect = $(".sticky-bar-offset-" + $groupId);
            if ($offsetSelect.length > 0) {
                var dropdownClone = $(dropdown).clone();
                if (dropdownClone.length > 0) {
                    dropdownClone[0].id = "hidden-sticky-bar-offset-" + $groupId;
                    dropdownClone.removeClass("select-offset").addClass("hidden sticky-bar-offset-" + $groupId);
                    $offsetSelect.replaceWith(dropdownClone);
                }
            }

            var $priceElement = $(".rim-price-element-" + $groupId);
            if ($priceElement.length > 0) {
                $priceElement.html(rims[0].price);
            }

            var $min30DayspriceElement = $(".rim-min-30-days-price-" + $groupId);
            if ($min30DayspriceElement.length > 0) {
                $min30DayspriceElement.html(rims[0].minPriceLast30Days);
            }

            var $reducedVoucherPrice = $(".reduced-price-value-" + $groupId);
            if ($reducedVoucherPrice.length > 0) {
                $reducedVoucherPrice.html(rims[0].reducedPrice);
            }

            var $voucherMessage = $(".voucher-campaign-message-" + $groupId);
            if ($voucherMessage.length > 0) {
                $voucherMessage.html(rims[0].message);
            }

            if (typeof $(dropdown).chosen != "undefined") {
                if ($(dropdown).data('chosen')) {
                    $(dropdown).trigger("chosen:updated");
                }
            } else {
                $(dropdown).trigger('change');
            }
        });
    });

    $(".select-offset").on("change", function (event) {
        changeOffset(this);
    });

    if ($('#preview-container').length) {
        vehicle = new Vehicle({imageElementId: "vehicle-preview"});
        vehicle.initImage((function() {
            $('.turn_car_right').fadeTo(700, 1, 'swing').on('mouseover', function () {
                $(this).css("opacity", ".7");
            });

            if (vehicle.tuning === 0) {
                $(".tuning .arrow-up").addClass("disabled");
            } else if (vehicle.tuning === 4) {
                $(".tuning .arrow-down").addClass("disabled");
            }
        }).bind(this));
    }

    if ($("#mtm-car-container").length) {
        $(".tuning .arrow-up").hide();
        $(".tuning .arrow-down").hide();
    }

    if ($('#complete_wheels_root').length) {
        $("#listing").on('click', '.rim-picture i', function () {
            var previewImageUrl = $(this).parent().find('img').data('preview-image-url');
            if (previewImageUrl) {
                $.fancybox({
                    href: previewImageUrl,
                    helpers: {
                        overlay: {
                            locked: false
                        }
                    }
                });
            }
            return false;
        });
    }

    if ($('.comparing-rims-container .rim_item').length > 0) {
        $('.stickyBarComparisonProducts').removeClass("hidden");
    }

    $("#complete_wheels_root").on('click', '#stickyBarCloseButtonWithCounter', function () {
        $('.stickyBarComparisonProducts').addClass("hidden");
        $('#stickyBarShowContainerButton').removeClass("hidden");
    });

    $("#complete_wheels_root").on('click', '#stickyBarShowContainerButton', function () {
        $('.stickyBarComparisonProducts').removeClass("hidden");
        $('#stickyBarShowContainerButton').addClass("hidden");
        updateContainerGroupsEqualHeightByMax();
    });

    $(".sticky-bar-compare-column").find(".rim_item ").on("click", function () {
        $(this).find("form").trigger('submit');
    });

    // Rim image preview on the rdlite rim tiles' magnifier (.quick-wiew-toggle): only the enlarged image
    // in a fancybox, without overlay and details, like the JSP rim selector's .rim-picture preview above.
    // Delegated so it keeps working after size-tab re-renders and on comparison-tray clones.
    $(document).on("click", ".quick-wiew-toggle", function (e) {
        e.preventDefault();
        var imageCover = $(this).attr("data-img-cover");
        if (imageCover && $.fancybox) {
            $.fancybox({
                href: imageCover,
                type: 'image',
                closeClick: true,
                helpers: {
                    overlay: null
                }
            });
        }
        return false;
    });

    $(window).on('resize', function () {
        updateContainerGroupsEqualHeightByMax();
    });

    window.THEME.$document.on('updateContainerGroupsEqualHeightByMax', function() {
        updateContainerGroupsEqualHeightByMax();
    });
};

var updateContainerGroupsEqualHeightByMax = function () {
    var containers = $('.sticky-bar-compare-wrapper .sticky-bar-comparison-product__top');

    containers.map(function () {
        $(this).css("height", 'auto');
    });
    var heights = containers.map(function () {
        return $(this).outerHeight();
    }).get();
    var maxHeight = Math.max.apply(null, heights);
    containers.map(function () {
        $(this).css("height", maxHeight);
    })
};

var updateComparisonSelection = function () {
    $("#comparing-rims").find(".item-rim").each(function () {
        var $this = $(this);
        var selectedSize = $this.data("selected-size");
        var selectedOffset = $this.find(".select-offset").val();
        var targetRim = $(".product-" + $(this).data("id"));
        var selectedTargetSize = targetRim.find("[data-rim-size='" + selectedSize + "']")
        highlightDimensionButton(selectedTargetSize);
        var targetOffsetSelector = targetRim.find(".select-offset");
        var targetWrapperSelector = targetRim.find(".selectWrapper");
        var sourceOffsetSelectorOptions = $this.find(".select-offset option").clone();
        var sourceSingleOption = $this.find(".selectWrapper .rim-info").clone();
        if (sourceOffsetSelectorOptions.length > 1) {
            targetOffsetSelector.find("option").remove();
            targetOffsetSelector.append(sourceOffsetSelectorOptions);
            targetOffsetSelector.val(selectedOffset);
        } else {
            targetWrapperSelector.find(".select-offset").hide();
            targetWrapperSelector.find(".rim-info").remove();
            targetWrapperSelector.append(sourceSingleOption);
        }
        targetRim.find(".rim-price").html($this.find(".rim-price").html());
    });
};

$(document).ready(function () {
    initRimsAddOnActions();
    updateContainerGroupsEqualHeightByMax();
    updateComparisonSelection();
});